import MasterCrudPage from "@/components/MasterCrudPage";

export default function TaskTypes() {
  return (
    <MasterCrudPage
      endpoint="/masters/task-types"
      title="Task Types"
      breadcrumbs={["Masters", "Task Types"]}
      testIdPrefix="task-type"
      initialForm={{ is_active: true, default_sla_hours: 48, default_priority_code: "MED" }}
      columns={[
        { key: "code", label: "Code", width: 120 },
        { key: "name", label: "Name" },
        { key: "default_sla_hours", label: "SLA (hrs)", width: 100 },
        { key: "default_approval_required", label: "Approval", render: r => r.default_approval_required ? "Yes" : "No", width: 100 },
        { key: "default_return_confirmation_required", label: "Return Conf.", render: r => r.default_return_confirmation_required ? "Yes" : "No", width: 110 },
      ]}
      formFields={[
        { key: "code", label: "Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "default_sla_hours", label: "Default SLA (hours)", type: "number" },
        { key: "default_approval_required", label: "Approval Required", type: "checkbox" },
        { key: "default_return_confirmation_required", label: "Return Confirmation Required", type: "checkbox" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
